import { useTranslation } from 'react-i18next';
import { Tooltip, Whisper } from 'rsuite';
import { icons } from '@shared/static/icons';
import { CountryFlag } from '@shared/ui/parts';
import { CopyToClipWhisper } from '@shared/ui/messages/CopyToClipWhisper';
import CopyToClipSensitiveCard from '@shared/ui/messages/CopyToClipSensitiveCard';
import { formatCardNumberSpaces } from '@utils/helpers';
import { cardTypeLabels, binsLogo } from '@utils/static';

export default function CardDisplay({ data }) {
  const { t } = useTranslation();
  const { id, type, owner, details } = data;

  return (
    <div className="cardDisplay">
      {icons['edit-card-bg']}
      <div className="cardDisplay__heading">
        <div className="cardDisplay__logo">
          <CountryFlag countryCode={binsLogo[details?.bank_id]} />
        </div>
        <div>
          <p className="cardDisplay__text">{details?.bank_public_name}</p>
          <p className="cardDisplay__bin">BIN {details?.bin}</p>
        </div>
        {icons[`${details?.paymentMethod}-card`]}
      </div>
      <div className="cardDisplay__inner">
        <CopyToClipSensitiveCard
          cardId={id}
          sensitiveDataKey="pan"
          classes="cardDisplay__number cardDisplay__text--value white-border"
          display={formatCardNumberSpaces(details?.cardNumber)}
        />
        <div className="cardDisplay__holder">
          <div className="cardDisplay__group">
            <p className="cardDisplay__label">{t('cardholder')}</p>
            <CopyToClipWhisper
              value={owner?.name}
              display={owner?.name}
              classes="cardDisplay__text cardDisplay__text--value white-border"
            />
          </div>
          <Whisper
            placement="auto"
            controlId="control-id-hover"
            trigger="hover"
            speaker={
              <Tooltip>
                {t('cardholder_tooltip')}
                <br />
                <br />
                {t('cardholder_tooltip_aml')}
              </Tooltip>
            }
          >
            <button className="cardDisplay__hint">{icons.hint}</button>
          </Whisper>
        </div>
        <div className="cardDisplay__bottom">
          <div className="cardDisplay__group">
            <p className="cardDisplay__label">{t('valid_thru')}</p>
            <CopyToClipSensitiveCard
              cardId={id}
              sensitiveDataKey="exp_date"
              classes="cardDisplay__text cardDisplay__text--value white-border"
            />
          </div>
          <div className="cardDisplay__group">
            <p className="cardDisplay__label">{t('cvv')}</p>
            <CopyToClipSensitiveCard
              cardId={id}
              display="XXX"
              sensitiveDataKey="cvv"
              classes="cardDisplay__text cardDisplay__text--value white-border"
            />
          </div>
          <div className="cardDisplay__type">{t(cardTypeLabels[type])}</div>
        </div>
      </div>
    </div>
  );
}
